import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface LocationOption {
  id: string;
  name: string;
}

/**
 * Flat org locations shaped for select inputs (id + name). Cached as reference data
 * (staleTime) so reopening a picker doesn't refetch the whole list each time.
 */
export function useLocationOptions(organizationId?: string) {
  return useQuery({
    queryKey: ['locations', 'options', organizationId ?? ''] as const,
    queryFn: async (): Promise<LocationOption[]> => {
      if (!organizationId) return [];
      const { data, error } = await supabase
        .from('locations')
        .select('id, name')
        .eq('organization_id', organizationId)
        .order('name');
      if (error) throw error;
      return (data ?? []) as LocationOption[];
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
}
